import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { Button } from "reactstrap";
import { getDropdownCountryList } from "../../../service/rak-beneficiary-service";

const RechargeBenificiariesFilterBy = ({
  show = false,
  onHide,
  saveButtonClicked,
  type, 
  setType,
  country,
  setCountry,setFilterLength,filterLength,setNoOfFiltersSelected
}) => {
  // const [type, setType] = useState([]);
  // const [country, setCountry] = useState([]);
  // const [typeLength, setTypeLength] = useState("");
  const [typeList, setTypeList] = useState([
    { value: "Local", label: "Local" },
    { value: "International", label: "International" },
  ]);
  const [countryList, setCountryList] = useState([]);
  // const [countryLength, setCountryLength] = useState("");

  useEffect(() => {
    getDropdownCountryListDD();
  }, []);

  const getDropdownCountryListDD = () => {
    //   api calls :
    getDropdownCountryList("ALL")
      .then((getDropdownCountryListRes) => {
        if (getDropdownCountryListRes && getDropdownCountryListRes.data) {
          let data = getDropdownCountryListRes.data.map((element) => {
            element.label = element.name || "";
            element.value = element.code || "";
            return element;
          });
          setCountryList(data);
        }
      })
      .catch((getDropdownCountryListErr) => {
        console.log({ getDropdownCountryListErr });
        setCountryList([]);
      });
  };
  return (
    <>
      <Modal
        onHide={onHide}
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="rak-beneficiary-modal"
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Type"
              onChange={(data) => {
                console.log("Selected Type", data);
                setType(data);
                setFilterLength(prevState => ({
                  ...prevState,
                 typeLength: ((data && data.length) || "")
              }));
              }}
              options={typeList}
              value={type}
            />
          </div>
        </Modal.Body>
        <Modal.Body>
          <div>
            <Select
              closeMenuOnSelect={true}
              isMulti
              placeholder="Country"
              onChange={(data) => {
                setCountry(data);
                setFilterLength(prevState => ({
                  ...prevState,
              countryLength: ((data && data.length) || "")
              }));
              }}
              options={countryList}
              value={country}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              onHide();
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            color="primary"
            onClick={() => {
              let req = {};
              req.type = type;
              req.country = country;
              req.typeLength =  filterLength.typeLength;
              req.countryLength = filterLength.countryLength;
              let temp =
              ( filterLength.typeLength || 0 )+
              ( filterLength.countryLength || 0) ;
              console.log("noOfFiltersSelected1",temp)
            setNoOfFiltersSelected(temp);
            temp=0;
              saveButtonClicked(req);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RechargeBenificiariesFilterBy;
